<template>
  <router-link
    to="/my-class"
    class="homework-cta"
  >
    <div class="homework-btn">
      <span class="homework-btn__icon">
        <b-icon
          icon="book-open"
          size="is-medium"
        />
      </span>
      <span class="homework-btn__label">Homework</span>
      <span class="homework-btn__badge">{{ count }}</span>
    </div>
  </router-link>
</template>

<script>
export default {
  name: "HomeworkCtaButton",

  props: {
    count: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style scoped>
.homework-cta {
  display: flex;
  width: 100%;
  text-decoration: none;
}

.homework-btn {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
  padding: 1rem 1.5rem;
  background: linear-gradient(135deg, #1e88e5 0%, #1053a0 100%);
  border-radius: 50px;
  box-shadow: 0 4px 12px rgba(16, 83, 160, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.25);
  color: #fff;
  font-size: 1.4rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  cursor: pointer;
  transition: transform 0.1s ease, box-shadow 0.1s ease;
}

.homework-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(16, 83, 160, 0.5), inset 0 1px 0 rgba(255, 255, 255, 0.25);
}

.homework-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 6px rgba(16, 83, 160, 0.4);
}

.homework-btn__badge {
  position: absolute;
  top: -8px;
  right: -8px;
  min-width: 24px;
  height: 24px;
  padding: 0 6px;
  background: #e53935;
  border-radius: 12px;
  border: 2px solid #fff;
  color: #fff;
  font-size: 0.75rem;
  font-weight: 800;
  line-height: 20px;
  text-align: center;
}
</style>
